import { SVGProps, Ref, forwardRef, useId } from 'react';

export const TalantixBrandSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => {
    const _uniqueId = useId();
    return (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    d="M17.534 3.042c-.546 0-.962.178-1.76.662-.41.251-.545.325-.741.423a8.2 8.2 0 0 1-2.024.644c-.24.043-.46.067-.662.086-.141.012-.24.012-.343.012h-.007c-.116 0-.208 0-.35-.012a6 6 0 0 1-.661-.08 8 8 0 0 1-2.012-.65c-.196-.092-.318-.165-.73-.417-.802-.484-1.225-.668-1.777-.668-.896 0-1.699.356-2.373 1.024l-.05.043c-.661.686-1.023 1.484-1.023 2.391 0 .546.178.957.668 1.754.251.417.325.545.417.742.325.705.54 1.385.65 2.03.037.238.067.459.08.655.012.141.012.233.012.344 0 .098 0 .202-.012.337-.019.202-.037.429-.086.662a8 8 0 0 1-.644 2.023l-.074.148c-.085.159-.14.263-.349.6-.484.798-.662 1.208-.662 1.748 0 .895.355 1.692 1.024 2.373l.037.037c.674.674 1.483 1.036 2.385 1.036.576 0 1.036-.202 1.87-.711.417-.258.472-.295.631-.374a8.6 8.6 0 0 1 2.024-.644q.359-.057.662-.086c.141-.012.24-.012.343-.012.098 0 .203 0 .338.012.202.018.416.037.656.086.643.11 1.318.313 2.023.637l.006.007c.16.085.215.122.632.374.834.509 1.293.71 1.876.71.89 0 1.68-.349 2.36-1.017.669-.68 1.092-1.539 1.092-2.434 0-.546-.184-.963-.668-1.76-.258-.41-.325-.546-.423-.742a8.6 8.6 0 0 1-.644-2.023c-.037-.245-.068-.46-.086-.662-.006-.141-.012-.24-.012-.344 0-.11.006-.208.012-.343.018-.203.037-.423.086-.656.11-.65.319-1.33.644-2.03l.018-.03c.086-.19.16-.313.405-.712.484-.797.668-1.214.668-1.753 0-.902-.362-1.699-1.024-2.38l-.037-.036c-.68-.662-1.483-1.024-2.385-1.024"
                    fill={`url(#${_uniqueId}paint0_linear_9138_2271)`}
                    suppressHydrationWarning
                />
                <path
                    d="M12.01 1h-.062c-.852.006-1.63.27-2.244.89-.368.373-.533.9-.668 1.434l.19.098c.901.423 1.888.668 2.716.668.393 0 1.435-.067 2.741-.674l.24-.123c-.136-.527-.301-1.042-.663-1.41-.625-.613-1.404-.877-2.25-.883"
                    fill="#2A7FEE"
                    fillOpacity={0.15}
                />
                <path
                    d="M3.321 9.05c-.54.136-1.066.295-1.44.67-.614.612-.877 1.391-.883 2.243v.056c.006.852.27 1.637.883 2.256.367.368.876.546 1.404.68l.128-.245c.626-1.361.675-2.44.675-2.74 0-.387-.068-1.43-.675-2.741z"
                    fill="#2A7FEE"
                    fillOpacity={0.15}
                />
                <path
                    d="m20.57 9.032-.105.197c-.607 1.306-.668 2.348-.668 2.734 0 .3.049 1.392.674 2.741l.13.245c.545-.135 1.084-.294 1.458-.674.614-.62.877-1.392.883-2.244v-.056c-.006-.858-.263-1.643-.883-2.262-.38-.38-.932-.54-1.49-.68"
                    fill="#2A7FEE"
                    fillOpacity={0.15}
                />
                <path
                    d="M11.936 19.836c-.3 0-1.367.05-2.71.662l-.233.135c.141.546.313 1.086.699 1.472.613.62 1.392.883 2.244.889l.061.006c.853-.006 1.625-.27 2.238-.889.374-.374.534-.908.669-1.447-.092-.055-.184-.11-.27-.153-1.33-.626-2.398-.675-2.698-.675"
                    fill="#2A7FEE"
                    fillOpacity={0.15}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.72 9.008h-2.048v6.634c0 .374-.233.564-.711.564-.479 0-.712-.196-.712-.564V9.008H9.202c-.374 0-.565-.203-.565-.632 0-.41.197-.619.565-.619h5.512q.563.001.564.62c.012.428-.184.63-.558.63"
                    fill="white"
                />
            </g>
            <defs>
                <linearGradient
                    id={`${_uniqueId}paint0_linear_9138_2271`}
                    x1={3.983}
                    y1={4.005}
                    x2={19.968}
                    y2={19.99}
                    gradientUnits="userSpaceOnUse"
                    suppressHydrationWarning
                >
                    <stop stopColor="#6D44D4" />
                    <stop offset={1} stopColor="#2A7FEE" />
                </linearGradient>
            </defs>
        </svg>
    );
});
TalantixBrandSize24Glyph.displayName = 'TalantixBrandSize24Glyph';
